// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7q-0";
export var startPickingButton = "_7q-1";